import { ref, onMounted } from 'vue';
import { getAdvertising } from '@/models/api/widgetApi';
import constants, { encryptedMarketplaceId } from '@/constants';
export function getWidget(pageType, isCurrentPageCall = false) {
  const LOOP_TYPE = {
    AUTO: 2,
    NON_AUTO: 1
  };
  const MS_IN_SECOND = 1000;
  const APP_QUERY_TYPE = 0; // APP
  const widgetInfo = ref(null);
  async function getWidgetImage(categoryId = '') {
    try {
      const { data } = await getAdvertising({
        paramType: APP_QUERY_TYPE,
        language:
          constants.ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[encryptedMarketplaceId],
        marketplaceId: encryptedMarketplaceId,
        pageType,
        categoryId
      });
      widgetInfo.value = data.data ?? null;
    } catch (error) {
      console.error(error, 'api---error---getAdvertising');
    }
  }
  onMounted(() => {
    if (isCurrentPageCall) {
      getWidgetImage();
    }
  });
  return {
    LOOP_TYPE,
    MS_IN_SECOND,
    widgetInfo,
    getWidgetImage
  };
}
